import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box } from '@mui/material';
import Spinner from './Spinner';

const TITLE = 'Рабочее место не настроено для подписания документов с помощью ЭЦП';

const SUBTITLE_LINES = (
    <>
        - Не найдено действующей облачной ЭЦП<br />
        - Рабочее место не настроено для использования физической ЭЦП
    </>
);

interface WorkplaceNotReadyDialogProps {
    open: boolean;
    message?: string;
    loading?: boolean;
    onClose: () => void;
    onRetry: () => void;
}

const buttonSx = {
    borderColor: '#9588e8',
    color: '#9588e8',
    '&:hover': {
        borderColor: '#9588e8',
        backgroundColor: 'rgba(149, 136, 232, 0.08)',
    },
};

export const WorkplaceNotReadyDialog: React.FC<WorkplaceNotReadyDialogProps> = ({
    open,
    message,
    loading = false,
    onClose,
    onRetry,
}) => {
    return (
        <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ textAlign: 'center' }}>{TITLE}</DialogTitle>
            <DialogContent sx={{ overflow: 'visible' }}>
                {loading ? (
                    <Box 
                        position="relative" 
                        minHeight={140} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center"
                        sx={{ py: 3, overflow: 'visible' }}
                    >
                        <Spinner text="Проверка ЭЦП" />
                    </Box>
                ) : (
                    <>
                        <Typography variant="body2" component="div" sx={{ mb: message ? 1.5 : 0 }}>
                            {SUBTITLE_LINES}
                        </Typography>
                        {message ? (
                            <Typography component="div" variant="body2" dangerouslySetInnerHTML={{ __html: message }} />
                        ) : null}
                    </>
                )}
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
                <Button onClick={onClose} variant="outlined" sx={buttonSx} disabled={loading}>
                    Закрыть
                </Button>
                <Button onClick={onRetry} variant="outlined" sx={buttonSx} disabled={loading}>
                    Проверить снова
                </Button>
            </DialogActions>
        </Dialog>
    );
};
